import React, { useState, useEffect } from 'react';
import { NavLink, useLocation, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import classnames from "classnames";
import OtpInput from 'react-otp-input';
import {AUTH_LOGIN_SUCCESS, AUTH_LOGIN_FAIL} from "../../../actions/auth";
import { Input } from '../../../components/common/Input2'
import EyeIcon from '../../../assets/icons/eye.svg'
import EyeCancelIcon from '../../../assets/icons/eye-cancel.svg'
import logo from '../../../assets/icons/logo.png';
import { ReactComponent as NTIcon } from "../../../assets/icons/nt-logo.svg";
import { ReactComponent as BackIcon } from "../../../assets/icons/chevron-left-sm.svg";
import { Api } from "../../../api";
import { useTranslation } from "react-i18next";
import CircularProgress from '@material-ui/core/CircularProgress';

const formData = {
  username: {
    name: 'username',
    type: 'text',
    value: '',
    label: "Username",
    placeholder: "Username",
  },
  password: {
    name: 'password',
    type: 'password',
    value: '',
    label: "Password",
    placeholder: "Password",
  }
}

const Login = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const [loginError, setLoginError] = useState('');
  const [successMessage, setSuccessMessage] = useState('');
  const [loading, setLoading] = useState(false);

  const [show2FA, setShow2FA] = useState(false);
  const [otp, setOtp] = useState('');
  const [reference, setReference] = useState(null);

  const [form, setForm] = useState(formData);
  const { username, password } = form;
  
  // Handle success message from password reset
  useEffect(() => {
    if (location.state?.message) {
      setSuccessMessage(location.state.message);
      // Clear the message from location state
      navigate(location.pathname, { replace: true });
    }
  }, [location, navigate]);
  
  const showPassword = () => {
    setForm({
      ...form,
      password: {
        ...form.password,
        type: form.password.type === 'password' ? 'text' : 'password'      }
    });
  };
  
  const onChangeHandler = (e) => {
    loginError && setLoginError('');
    successMessage && setSuccessMessage('');
    const { value, name } = e.target;
    setForm({
      ...form,
      [name]: {
        ...form[name],        value: value
      }
    });
  };

  const onSubmit = async (e) => {
    e.preventDefault();
    if (username.value && password.value && !loading) {
      loginError && setLoginError('');
      reference && setReference(null);
      otp && setOtp('');
      
      setLoading(true);
      try {
        const auth = await Api.auth.login({
          username: username.value,
          password: password.value,
        });

        const { token } = auth.data;
        dispatch({ type: AUTH_LOGIN_SUCCESS, payload: { user: { ...auth.data, session_id: token }, username: username.value } });
        sessionStorage.setItem('username', username.value);
        sessionStorage.setItem('s_id', token);
        sessionStorage.setItem('user', JSON.stringify({ ...auth.data, session_id: token }));
        setLoading(false);
        navigate('/', { replace: true });
        
      } catch (error) {
        setLoading(false);
        if (error?.response?.data?.message === 'OTP Required') {
          setShow2FA(true);
          setReference(error?.response?.data?.reference);
        }
        else {
          error?.response?.data?.message ? setLoginError(error?.response?.data?.message) : setLoginError('Failed to authenticate user');
          dispatch({ type: AUTH_LOGIN_FAIL });
        }
      }
    }
  }

  const validateOtp = async (e) => {
    e.preventDefault();
    if (otp && !loading) {
      loginError && setLoginError('');
      
      setLoading(true);
      try {
        const auth = await Api.auth.validateOtp({
          code: otp,
          reference,
        });

        const { token, userName } = auth.data;
        dispatch({ type: AUTH_LOGIN_SUCCESS, payload: { user: { ...auth.data, session_id: token }, username: userName } });
        sessionStorage.setItem('username', userName);
        sessionStorage.setItem('s_id', token);
        sessionStorage.setItem('user', JSON.stringify({ ...auth.data, session_id: token }));
        setLoading(false);
        navigate('/', { replace: true });
        
      } catch (error) {
        setLoading(false);
        error?.response?.data?.message ? setLoginError(error?.response?.data?.message) : setLoginError('Failed to authenticate user');
        dispatch({ type: AUTH_LOGIN_FAIL });
      }
    }
  }

  const goBack = () => {
    setForm(formData);
    setLoginError('');
    setShow2FA(false);
  }

  return (
    <div className="auth-card">
      {!show2FA ? <>
        <div className="auth-card-head">
          <img src={logo} alt="logo" />
        </div>
        <form className="auth-card-form">
          <Input
            {...username}
            onChange={onChangeHandler}
            t={t}
          />
          <Input
            {...password}
            rightIcon={<img src={EyeIcon} alt="" />}
            rightIcon2={<img src={EyeCancelIcon} alt="" />}
            showPassword={showPassword}
            onChange={onChangeHandler}
            t={t}          />

          {successMessage && <span className='auth-success'>{successMessage}</span>}
          {loginError && <span className='auth-failed'>{loginError}</span>}

          <button className={classnames({loading: loading})} type="submit" onClick={onSubmit}>{loading ? <CircularProgress color="inherit" /> : t('Sign In')}</button>

          <NavLink to='/auth/forgot-password' className='fPassUnder'>Forgot password?</NavLink>
          {/* <span className='loginO365'>Or Login with O365</span> */}

          <div className='loginO365-image'>
            <NTIcon />      
          </div>
        </form>
      </>
        : <form className="auth-card-form otp">
          <div className="otp-header">
            <div className="otp-back" onClick={goBack}><BackIcon /></div>
            <p>Enter 2FA Code</p>
          </div>
          <OtpInput
            value={otp}
            onChange={setOtp}
            containerStyle={'otp-inputs'}
            numInputs={6}
            renderSeparator={<span>-</span>}
            renderInput={(props) => <input {...props} />}
          />

          {loginError && <span className='auth-failed'>{loginError}</span>}

          <button className={classnames({loading: loading})} type="submit" onClick={validateOtp}>{loading ? <CircularProgress color="inherit" /> : t('Verify 2FA Code')}</button>

          <div className='loginO365-image'>
            <NTIcon />      
          </div>
        </form>
      }
    </div>
  )
}

export default Login;